module.exports = "/static/assets/f0fd98d115c67f4e223492e86cac6e9e.png";